import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UiState {
    locationsTableSelectedColumns: string[];
    customersTableSelectedColumns: string[];
    perksTableSelectedColumns: string[];
    audiencesTableSelectedColumns: string[];
    merchantsTableSelectedColumns: string[];
    ordersTableSelectedColumns: string[];
}

export const initialState: UiState = {
    locationsTableSelectedColumns: ['Title', 'State'],
    customersTableSelectedColumns: [],
    perksTableSelectedColumns: [],
    audiencesTableSelectedColumns: [],
    merchantsTableSelectedColumns: [],
    ordersTableSelectedColumns: [
        'Order Number',
        'Order Type',
        'Collection Time',
        'Order Details',
        'Order Value'
    ]
};

const updateSelectedColumns = (selectedColumns: string[], column: string, isChecked: boolean) => {
    if (isChecked) {
        return [...selectedColumns, column];
    }
    return selectedColumns.filter((selectedColumn: string) => selectedColumn !== column);
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        changeLocationsTableSelectedColumns: {
            reducer: (state, action: PayloadAction<string[]>) => {
                state.locationsTableSelectedColumns = action.payload;
            },
            prepare: (column: string, isChecked: boolean, currentColumns: string[]) => ({
                payload: updateSelectedColumns(currentColumns, column, isChecked)
            })
        },
        changeCustomersTableSelectedColumns: {
            reducer: (state, action: PayloadAction<string[]>) => {
                state.customersTableSelectedColumns = action.payload;
            },
            prepare: (column: string, isChecked: boolean, currentColumns: string[]) => ({
                payload: updateSelectedColumns(currentColumns, column, isChecked)
            })
        },
        changePerksTableSelectedColumns: {
            reducer: (state, action: PayloadAction<string[]>) => {
                state.perksTableSelectedColumns = action.payload;
            },
            prepare: (column: string, isChecked: boolean, currentColumns: string[]) => ({
                payload: updateSelectedColumns(currentColumns, column, isChecked)
            })
        },
        changeAudiencesTableSelectedColumns: {
            reducer: (state, action: PayloadAction<string[]>) => {
                state.audiencesTableSelectedColumns = action.payload;
            },
            prepare: (column: string, isChecked: boolean, currentColumns: string[]) => ({
                payload: updateSelectedColumns(currentColumns, column, isChecked)
            })
        },
        changeMerchantsTableSelectedColumns: {
            reducer: (state, action: PayloadAction<string[]>) => {
                state.merchantsTableSelectedColumns = action.payload;
            },
            prepare: (column: string, isChecked: boolean, currentColumns: string[]) => ({
                payload: updateSelectedColumns(currentColumns, column, isChecked)
            })
        },
        changeOrdersTableSelectedColumns: {
            reducer: (state, action: PayloadAction<string[]>) => {
                state.ordersTableSelectedColumns = action.payload;
            },
            prepare: (column: string, isChecked: boolean, currentColumns: string[]) => ({
                payload: updateSelectedColumns(currentColumns, column, isChecked)
            })
        }
    }
});

export const {
    changeLocationsTableSelectedColumns,
    changeCustomersTableSelectedColumns,
    changePerksTableSelectedColumns,
    changeAudiencesTableSelectedColumns,
    changeMerchantsTableSelectedColumns,
    changeOrdersTableSelectedColumns
} = uiSlice.actions;
export default uiSlice.reducer;
